import { createModel, RematchDispatch } from '@rematch/core';
import { getDefaultIconSet } from '../../services/iconSet.service';
import { IconSetData } from '../../types/IconSetData';
import { RootModel } from '../models';

import baseEntity from './base.entity';

export const storeName = 'iconSetEntity';

export const iconSetEntity: any = createModel<RootModel>()({
  name: storeName,
  state: { ids: {} },
  reducers: {
    ...baseEntity,
  },
  effects: (dispatch: RematchDispatch<typeof iconSetEntity>) => ({
    async getDefaultSet(id): Promise<IconSetData> {
      const res = await getDefaultIconSet();
      const iconSet = res.data;
      if (iconSet) {
        this.saves([iconSet]);
      }
      return iconSet;
    },
  }),
});

export default iconSetEntity;
